/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_CtaInputs */

const tr_landing_web_cta = /** @type {(inputs: Landing_Web_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel’i ücretsiz deneyin`)
};

const en_landing_web_cta = /** @type {(inputs: Landing_Web_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try ShopPanel for free`)
};

const de_landing_web_cta = /** @type {(inputs: Landing_Web_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel kostenlos testen`)
};

const ru_landing_web_cta = /** @type {(inputs: Landing_Web_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать ShopPanel бесплатно`)
};

/**
* | output |
* | --- |
* | "Try ShopPanel for free" |
*
* @param {Landing_Web_CtaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_cta = /** @type {((inputs?: Landing_Web_CtaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_CtaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_cta(inputs)
	if (locale === "de") return de_landing_web_cta(inputs)
	if (locale === "ru") return ru_landing_web_cta(inputs)
	return tr_landing_web_cta(inputs)
});